import { render, staticRenderFns } from "./InterviewRejected.vue?vue&type=template&id=1545bae7&scoped=true&"
import script from "./InterviewRejected.vue?vue&type=script&lang=js&"
export * from "./InterviewRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545bae7",
  null
  
)

export default component.exports